"use client";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";
import { UI } from "@/constants";
import { NavLink } from "./NavLink";
import { NavSubLinks } from "./NavSubLinks";

export const NavBar = () => {
  return (
    <NavigationMenu>
      <NavigationMenuList className="flex-wrap">
        {UI.navigation.map(({ key, ...rest }) => (
          <NavigationMenuItem key={key}>
            {rest.subMenu ? <NavSubLinks {...rest} /> : <NavLink {...rest} />}
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
};
